import { render, staticRenderFns } from "./AdminApp.vue?vue&type=template&id=06f49370&scoped=true"
import script from "./AdminApp.vue?vue&type=script&lang=js"
export * from "./AdminApp.vue?vue&type=script&lang=js"
import style0 from "./AdminApp.vue?vue&type=style&index=0&id=06f49370&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f49370",
  null
  
)

export default component.exports